import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

const CatalogoCrud = ({ title, endpoint, fields }) => {
  const [data, setData] = useState([]);
  const [form, setForm] = useState({});
  const [visible, setVisible] = useState(false);
  const [editando, setEditando] = useState(false);

    const axiosPrivate = useAxiosPrivate();
  const loadData = async () => {
    const res = await axiosPrivate.get(endpoint);
    setData(res.data);
  };

  useEffect(() => {
    loadData();
  }, []);

  const save = async () => {
    if (editando) {
      await axiosPrivate.put(`${endpoint}/${form.id}`, form);
    } else {
      await axiosPrivate.post(endpoint, form);
    }

    setVisible(false);
    loadData();
  };

  const edit = (row) => {
    setForm(row);
    setEditando(true);
    setVisible(true);
  };

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar?")) return;
    await axiosPrivate.delete(`${endpoint}/${id}`);
    loadData();
  };

  return (
    <div>
      <h3>{title}</h3>

      <Button label="Nuevo" onClick={() => {
        setForm({});
        setEditando(false);
        setVisible(true);
      }} />

      <DataTable value={data}>
        {fields.map(f => (
          <Column key={f.name} field={f.name} header={f.label} />
        ))}

        <Column
          header="Acciones"
          body={(row) => (
            <div className="flex gap-2">
              <Button icon="pi pi-pencil" onClick={() => edit(row)} />
              <Button icon="pi pi-trash" onClick={() => remove(row.id)} />
            </div>
          )}
        />
      </DataTable>

      <Dialog header={title} visible={visible} onHide={() => setVisible(false)}>
        {fields.map(f => (
          <div className="field" key={f.name}>
            <label>{f.label}</label>
            <InputText
              value={form[f.name] || ""}
              onChange={(e) =>
                setForm({ ...form, [f.name]: e.target.value })
              }
            />
          </div>
        ))}

        <Button label="Guardar" onClick={save} />
      </Dialog>
    </div>
  );
};
export default CatalogoCrud;